import { titleCase } from "../../util/string";

export enum AvailabilityType {
  game = "game",
  medical = "medical",
  personal = "personal",
  school = "school",
}

export namespace AvailabilityType {
  export function fromString(value: string): AvailabilityType {
    switch (value) {
      case AvailabilityType.game:
        return AvailabilityType.game;
      case AvailabilityType.medical:
        return AvailabilityType.medical;
      case AvailabilityType.personal:
        return AvailabilityType.personal;
      case AvailabilityType.school:
        return AvailabilityType.school;
    }
    console.error(new Error("Unexpected availability type"));
    return AvailabilityType.personal;
  }

  export function all(): AvailabilityType[] {
    return [
      AvailabilityType.game,
      AvailabilityType.medical,
      AvailabilityType.personal,
      AvailabilityType.school,
    ];
  }

  export function forManual(): AvailabilityType[] {
    return [
      AvailabilityType.personal,
      AvailabilityType.medical,
      AvailabilityType.school,
    ];
  }

  export function toString(type: AvailabilityType): string {
    switch (type) {
      case AvailabilityType.game:
        return "Game";
      case AvailabilityType.medical:
        return "Medical";
      case AvailabilityType.personal:
        return "Personal";
      case AvailabilityType.school:
        return "School";
    }

    return titleCase(type);
  }
}
